import ReactGA from 'react-ga'
import ReactPixel from 'react-facebook-pixel'

let lastPage = ''

const GOOGLE_ADS_ID = 'AW-17874559336'

const CONVERSION_LABELS = {
  PURCHASE: '8rlrCJWX24EdEOjCoMtC',
  START_DESIGNING: 'WSYbCKX23IEdEOjCoMtC',
  ADD_TO_CART: 'S6MTCKL23IEdEOjCoMtC',
}

export function initialize(history) {
  ReactGA.initialize('UA-76462208-3')
  ReactPixel.init('4889349244437566')
  
  loadGoogleAds()
  
  history.listen(location => reportPageView(location))
  reportPageView(history.location)
}

function loadGoogleAds() {
  if (typeof window === 'undefined') return
  
  if (!window.gtag) {
    const script = document.createElement('script')
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ADS_ID}`
    document.head.appendChild(script)
    
    window.dataLayer = window.dataLayer || []
    window.gtag = function() {
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
  }
  
  window.gtag('config', GOOGLE_ADS_ID)
}

function reportPageView(location) {
  const newPage = location.pathname + location.search
  if (newPage !== lastPage) {
    lastPage = newPage
    ReactGA.pageview(lastPage)
    ReactPixel.pageView()
    
    if (window.gtag) {
      window.gtag('config', GOOGLE_ADS_ID, {
        page_path: newPage
      })
    }
  }
}

export function trackPurchase(value, currency = 'USD', transactionId, callback) {
  if (!CONVERSION_LABELS.PURCHASE) {
    if (callback) callback()
    return
  }
  
  if (typeof window !== 'undefined' && window.gtag) {
    let callbackFired = false
    
    const safeCallback = () => {
      if (!callbackFired && callback) {
        callbackFired = true
        callback()
      }
    }
    
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${CONVERSION_LABELS.PURCHASE}`,
      value: value,
      currency: currency,
      transaction_id: transactionId,
      event_callback: safeCallback
    })
    
    setTimeout(safeCallback, 2000)
  } else {
    if (callback) callback()
  }
}

export function trackStartDesigning() {
  if (!CONVERSION_LABELS.START_DESIGNING) {
    console.warn('[Google Ads] Start Designing conversion label not configured. Update CONVERSION_LABELS.START_DESIGNING in analytics.js.')
    return
  }
  
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${CONVERSION_LABELS.START_DESIGNING}`
    })
  }
}

export function trackAddToCart(value, currency = 'USD') {
  if (!CONVERSION_LABELS.ADD_TO_CART) {
    return
  }
  
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', 'conversion', {
      send_to: `${GOOGLE_ADS_ID}/${CONVERSION_LABELS.ADD_TO_CART}`,
      value: value,
      currency: currency
    })
  }
}
